import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home';
import { NosotrosComponent } from './pages/nosotros/nosotros';
import { ServiciosComponent } from './pages/servicios/servicios';
import { ProductosComponent } from './pages/productos/productos';
import { PortafolioComponent } from './pages/portafolio/portafolio';
import { ContactoComponent } from './pages/contacto/contacto';
import { TrabajaConNosotrosComponent } from './pages/trabaja-con-nosotros/trabaja-con-nosotros.component';
import { AeropuertoComponent } from './pages/proyectos/aeropuerto/aeropuerto';
import { AltoPiuraComponent } from './pages/proyectos/alto-piura/alto-piura';
import { CarreteraLimaComponent } from './pages/proyectos/carretera-lima/carretera-lima';
import { LagunaComponent } from './pages/proyectos/laguna/laguna';
import { LineaAmarillaComponent } from './pages/proyectos/linea-amarilla/linea-amarilla';
import { MetroLimaComponent } from './pages/proyectos/metro-lima/metro-lima';
import { PlantaSedapalComponent } from './pages/proyectos/planta-sedapal/planta-sedapal';
import { CalidadComponent } from './pages/politicas/calidad/calidad';
import { PrivacidadComponent } from './pages/politicas/privacidad/privacidad';
import { LoginComponent } from './pages/admin/login/login';
import { DashboardComponent } from './pages/admin/dashboard/dashboard';
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'nosotros', component: NosotrosComponent },
  { path: 'servicios', component: ServiciosComponent },
  { path: 'productos', component: ProductosComponent },
  { path: 'portafolio', component: PortafolioComponent },
  { path: 'contacto', component: ContactoComponent },
  { path: 'trabaja-con-nosotros', component: TrabajaConNosotrosComponent },
  
  // Proyectos
  { path: 'proyectos/aeropuerto', component: AeropuertoComponent },
  { path: 'proyectos/alto-piura', component: AltoPiuraComponent },
  { path: 'proyectos/carretera-lima', component: CarreteraLimaComponent },
  { path: 'proyectos/laguna', component: LagunaComponent },
  { path: 'proyectos/linea-amarilla', component: LineaAmarillaComponent },
  { path: 'proyectos/metro-lima', component: MetroLimaComponent },
  { path: 'proyectos/planta-sedapal', component: PlantaSedapalComponent },
  
  // Políticas
  { path: 'politica-calidad', component: CalidadComponent },
  { path: 'politica-privacidad', component: PrivacidadComponent },
  
  // Admin
  { path: 'admin/login', component: LoginComponent },
  { path: 'admin/dashboard', component: DashboardComponent, canActivate: [authGuard] },
  
  { path: '**', redirectTo: '' }
];
